import type React from "react";
import type { ITableConfiguration } from "./tcConstants";

export const transformHiddenColumnsValuesForFilter = (
  typeFilter: any,
  columnValues: any
) => {
  if (!typeFilter || typeof typeFilter !== "object") {
    console.error(
      "Errore: 'typeFilter' è undefined, null o non un oggetto valido in transformHiddenColumnsValuesForFilter.",
      typeFilter
    );
    return {};
  }

  let returnObject = {};

  const safeColumnValues =
    columnValues && typeof columnValues === "object" ? columnValues : {};

  Object.values(typeFilter).forEach((value) => {
    if (Object.values(safeColumnValues).includes(value)) {
      // @ts-ignore
      const valueToAdd: string = Object.keys(typeFilter).find(
        (key) => typeFilter[key] === value
      );
      returnObject = {
        ...returnObject,
        [valueToAdd]: valueToAdd,
      };
    }
  });
  return returnObject;
};

export const transformColumnOrderValuesForFilter = (
  typeFilter: any,
  columnOrder: string[]
) => {
  if (columnOrder.length < 1) return [];

  if (!typeFilter || typeof typeFilter !== "object") {
    console.error(
      "Errore: 'typeFilter' è undefined, null o non un oggetto valido in transformColumnOrderValuesForFilter.",
      typeFilter
    );
    return [];
  }

  const returnArray = [] as string[];
  // @ts-ignore
  columnOrder.forEach((value: string) => {
    if (Object.values(typeFilter).includes(value)) {
      returnArray.push(
        // @ts-ignore
        Object.keys(typeFilter).find((key) => typeFilter[key] === value)
      );
    }
  });
  return returnArray;
};

export const computeBlockSimpleSearchFilter = (
  hiddenColumns: any,
  simpleFilterFields: string[]
) => {
  let blockSimpleSearchFilter = false;
  simpleFilterFields?.forEach((field) => {
    if (Object.values(hiddenColumns).includes(field)) {
      blockSimpleSearchFilter = true;
    }
  });
  return blockSimpleSearchFilter;
};

export const makeObjectToUpperCase = (object: any) => {
  const objectToReturn = Object.keys(object).reduce(
    (array: any, key: string) => ({
      ...array,
      [key.toUpperCase()]: object[key].toUpperCase(),
    }),
    {}
  );
  return objectToReturn;
};

export const setTableConfigurationState = (
  table: ITableConfiguration,
  setcolumnOrder: React.Dispatch<React.SetStateAction<string[]>>,
  setHideCells: React.Dispatch<React.SetStateAction<{}>> | null,
  setHideColumns: React.Dispatch<React.SetStateAction<{}>>
) => {
  if (table) {
    const tmpColumnOrder = [] as string[];
    let tmpHideColumns = {};
    table.columns.forEach((column) => {
      tmpColumnOrder[column.position - 1] = column.key;
      if (!column.visibility) {
        tmpHideColumns = {
          ...tmpHideColumns,
          [column.key]: column.key,
        };
      }
    });
    setcolumnOrder(tmpColumnOrder);
    setHideColumns(tmpHideColumns);
    if (setHideCells) setHideCells(makeObjectToUpperCase(tmpHideColumns));
  }
};

export const setFilterConfigurationState = (
  table: ITableConfiguration,
  typeFilter: any,
  simpleFilterFields: string[],
  setHideColumns: React.Dispatch<React.SetStateAction<{}>>,
  setColumnOrder: React.Dispatch<React.SetStateAction<string[]>>,
  setBlockAdvancedFilter: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (table) {
    const tmpColumnOrder = [] as string[];
    let tmpHideColumns = {};
    table.columns.forEach((column) => {
      tmpColumnOrder[column.position - 1] = column.key;
      if (!column.visibility) {
        tmpHideColumns = {
          ...tmpHideColumns,
          [column.key]: column.key,
        };
      }
    });
    setHideColumns(
      transformHiddenColumnsValuesForFilter(typeFilter, tmpHideColumns)
    );
    setColumnOrder(
      transformColumnOrderValuesForFilter(typeFilter, tmpColumnOrder)
    );
    setBlockAdvancedFilter(
      computeBlockSimpleSearchFilter(tmpHideColumns, simpleFilterFields)
    );
  }
};
